import {getAliasHeader} from './constants';
import {threeSixtyApiUrl} from './services';

import {
	MrcEntryResponse,
	MrcTemplatesListResponse,
	MrcErrorResponse,
	MrcListRequest,
	MrcListResponse,
	BrregApiResponse,
	MrcEntryCreateRequest
} from 'common/types/store/mrcTypes';

export const getMrcList = async (params: MrcListRequest): Promise<MrcListResponse> => {
	try {
		const response = await fetch(`${threeSixtyApiUrl}mrcs/list`, {
			method: 'POST',
			headers: {
				...getAliasHeader(),
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(params),
		});
		if (!response.ok) throw await response.json() as MrcErrorResponse;
		return response.json();
	} catch (err) {
		console.error('Error fetching MRC list:', err);
		throw err;
	}
};

export const getMrcEntryById = async (id: number): Promise<MrcEntryResponse> => {
	try {
		const response = await fetch(`${threeSixtyApiUrl}mrc/${id}`, {
			headers: {
				...getAliasHeader(),
				'Content-Type': 'application/json',
			},
		});
		if (!response.ok) throw await response.json() as MrcErrorResponse;
		return response.json();
	} catch (err) {
		console.error(`Error fetching MRC entry with ID ${id}:`, err);
		throw err;
	}
};

export const getMrcTemplatesList = async (): Promise<MrcTemplatesListResponse> => {
	try {
		const response = await fetch(`${threeSixtyApiUrl}mrctemplates/list`, {
			method: 'GET',
			headers: {
				...getAliasHeader(),
				'Content-Type': 'application/json',
			},
		});
		if (!response.ok) throw await response.json() as MrcErrorResponse;
		return response.json();
	} catch (err) {
		console.error('Error fetching MRC templates:', err);
		throw err;
	}
};

export const createMrcEntry = async (data: MrcEntryCreateRequest): Promise<MrcEntryResponse> => {
	try {
		const response = await fetch(`${threeSixtyApiUrl}mrc`, {
			method: 'POST',
			headers: {
				...getAliasHeader(),
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		});
		if (!response.ok) throw await response.json() as MrcErrorResponse;
		return response.json();
	} catch (err) {
		console.error('Error creating MRC entry:', err);
		throw err;
	}
};

// brreg api fetch
export const getBrregOrg = async (orgNumber: string): Promise<BrregApiResponse> => {
	try {
		const response = await fetch(`https://data.brreg.no/enhetsregisteret/api/enheter/${orgNumber}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		});
		if (!response.ok) {
			throw new Error('Error fetching organization data for org number');
		};
		return response.json();
	} catch (err) {
		console.error('Error fetching organization data for org number', err);
		throw err;
	}
};
